import React from 'react';
import AdminDashboardLayout from '../../layout/dashboard/AdminDashboardLayout';
import RolesAndPermissions from '../../features/roles-permissions/RolesAndPermissions';

const AdminRolesPermissionsPage = () => {
  return (
    <AdminDashboardLayout>
      <RolesAndPermissions context="super-admin" />
    </AdminDashboardLayout>
  );
};

export default AdminRolesPermissionsPage;
